import React from "react"
import ProjectList from "../../../../../TaskManagement/components/ProjectList/Index/index"
function Presentation(props) {
  const { placementSettings, isEmpty } = props
  let reqProjects = Object.values(placementSettings).map((e) => e.linkToProject)
  return <ProjectList reqProjects={reqProjects} isClientView={true} />
}

export default Presentation
